if (!customElements.get('fa26-moments')) {
  class Fa26Moments extends HTMLElement {
    constructor() {
      super();
      this.hoverMedia = window.matchMedia('(hover: hover)');
      this.desktopMedia = window.matchMedia('(min-width: 768px)');
      this.reducedMotionMedia = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.activeIndex = null;
      this.selectedIndex = null;
      this.bound = false;
      this.onWordEnter = this.onWordEnter.bind(this);
      this.onListLeave = this.onListLeave.bind(this);
      this.onFocusIn = this.onFocusIn.bind(this);
      this.onFocusOut = this.onFocusOut.bind(this);
      this.onClick = this.onClick.bind(this);
      this.applyReducedMotion = this.applyReducedMotion.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
    }

    init() {
      this.destroy();
      this.list = this.querySelector('[data-fa26-words]');
      this.words = Array.from(this.querySelectorAll('.fa26-moments__word'));
      this.layers = Array.from(this.querySelectorAll('.fa26-moments__layer'));
      if (!this.list || this.words.length === 0) return;
      this.applyReducedMotion();
      this.words.forEach((word) => word.addEventListener('mouseenter', this.onWordEnter));
      this.list.addEventListener('mouseleave', this.onListLeave);
      this.list.addEventListener('focusin', this.onFocusIn);
      this.list.addEventListener('focusout', this.onFocusOut);
      this.list.addEventListener('click', this.onClick);
      this.reducedMotionMedia.addEventListener('change', this.applyReducedMotion);
      this.bound = true;
      this.reset();
    }

    destroy() {
      if (!this.bound) return;
      this.words.forEach((word) => word.removeEventListener('mouseenter', this.onWordEnter));
      this.list.removeEventListener('mouseleave', this.onListLeave);
      this.list.removeEventListener('focusin', this.onFocusIn);
      this.list.removeEventListener('focusout', this.onFocusOut);
      this.list.removeEventListener('click', this.onClick);
      this.reducedMotionMedia.removeEventListener('change', this.applyReducedMotion);
      this.bound = false;
    }

    applyReducedMotion() {
      this.classList.toggle('fa26-moments--static', this.reducedMotionMedia.matches);
    }

    indexOf(element) {
      return Number(element.dataset.fa26Index);
    }

    wordFrom(target) {
      return target instanceof Element ? target.closest('.fa26-moments__word') : null;
    }

    onWordEnter(event) {
      if (!this.hoverMedia.matches) return;
      this.activate(this.indexOf(event.currentTarget));
    }

    onListLeave() {
      if (!this.hoverMedia.matches) return;
      this.reset();
    }

    onFocusIn(event) {
      const word = this.wordFrom(event.target);
      if (word) this.activate(this.indexOf(word));
    }

    onFocusOut(event) {
      if (event.relatedTarget && this.list.contains(event.relatedTarget)) return;
      if (this.selectedIndex !== null) {
        this.activate(this.selectedIndex);
        return;
      }
      this.reset();
    }

    onClick(event) {
      const word = this.wordFrom(event.target);
      if (!word) return;
      if (this.hoverMedia.matches || !this.desktopMedia.matches) return;
      const index = this.indexOf(word);
      if (this.selectedIndex === index) return;
      event.preventDefault();
      this.select(index);
    }

    select(index) {
      this.selectedIndex = index;
      this.activate(index);
    }

    activate(index) {
      this.activeIndex = index;
      this.words.forEach((word) => {
        word.classList.toggle('is-active', this.indexOf(word) === index);
      });
      const hasOwnLayer = this.layers.some((layer) => this.indexOf(layer) === index);
      this.layers.forEach((layer) => {
        const layerIndex = this.indexOf(layer);
        const visible = layerIndex === 0 || (hasOwnLayer && layerIndex === index);
        layer.querySelectorAll('.fa26-fade').forEach((fade) => fade.classList.toggle('is-active', visible));
      });
    }

    reset() {
      this.activeIndex = null;
      this.selectedIndex = null;
      this.words.forEach((word) => word.classList.remove('is-active'));
      this.layers.forEach((layer) => {
        const visible = this.indexOf(layer) === 0;
        layer.querySelectorAll('.fa26-fade').forEach((fade) => fade.classList.toggle('is-active', visible));
      });
    }
  }

  customElements.define('fa26-moments', Fa26Moments);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('fa26-moments').forEach((element) => element.init());
  });

  document.addEventListener('shopify:block:select', (event) => {
    const element = event.target.closest('fa26-moments');
    const word = event.target.querySelector('.fa26-moments__word');
    if (element && word) element.select(element.indexOf(word));
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const element = event.target.closest('fa26-moments');
    if (element) element.reset();
  });
}
